module.exports = __webpack_public_path__ + "img/28-min.6fa1c905.jpg";